import { Form } from 'react-bootstrap';
import { MdPause, MdPlayArrow } from 'react-icons/md';
import { Button } from '@Components/Button';
import { Size } from '@Components/designConstants';
import { TimelinePlayback } from './useTimelinePlayback';

interface PlaybackControlsProps {
  dates: string[];
  playback: TimelinePlayback;
}

export const PlaybackControls = ({ dates, playback }: PlaybackControlsProps) => {
  const { dateIndex, isPlaying, toggle, setDateIndex } = playback;
  const currentDate = dates[dateIndex] ?? dates[0] ?? '';

  return (
    <div className='playback-controls'>
      <Button
        size={Size.SM}
        onClick={toggle}
        disabled={dates.length <= 1}
        aria-label={isPlaying ? 'Pause' : 'Play'}
      >
        {isPlaying ? <MdPause /> : <MdPlayArrow />}
      </Button>
      <Form.Range
        className='date-scrubber'
        min={0}
        max={Math.max(0, dates.length - 1)}
        value={dateIndex}
        onChange={event => setDateIndex(Number(event.target.value))}
      />
      <span className='current-date'>{currentDate}</span>
    </div>
  );
};
